import ShareEvent from './ShareEvent';
import ShareUtil from './ShareUtil';

class Share{
  constructor( options ){
    this.options = {
        $parent: $( 'body' ),
        //order: ['facebook', 'twitter', 'kakaotalk', 'kakaostory', 'line', 'googleplus', 'cat' ],
        order: ['facebook', 'twitter', 'kakaotalk', 'line', 'googleplus' ],
    		appid: 'http://kr.plaync.com',
    	  appver: '1.0',
        buttonMsg: '',
    	  appname: 'plaync',
        breakpoint: 960,
    	  img: '',
        imgWidth: 200,
        imgHeight: 150,
    	  msg: '엔씨소프트가 만든 즐거운 게임 포털, plaync!',
        description: '',
        url: location.href
    };

    $.extend( this.options, options );

    this.parentId = this.options.$parent.attr( 'id' ) || '';

    this.options.msg = this.replaceChars( this.options.msg );
    this.options.description = this.replaceChars( this.options.description );

    this.setUI( this.options.$parent );
    this.addEvent();
  }

  replaceChars( str ){
    return str.replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, '\'')
  }

  setUI( $parent ){
    let markup = this.setIconNode();
    markup = this.template( markup, $parent.attr( 'id' ) );

    if( this.options.$parent.is( $( 'body' ) ) ){
      this.options.$parent.append( markup );
    }else{
      this.options.$parent.replaceWith( markup );
    }
  }

  setIconNode(){
    let markup = '',
        order = this.options.order;

    for( var key in order ) {
      let title = order[ key ];
      markup += `<a class="share-${title}">${title}</a>`;
    }

    return markup;
  }

  template( iconNodes ){

    let _id = ( this.parentId )? `id="${this.parentId}" `: ``;

    let markup = `<div ${_id} class="ncUiKitShare share">
        <div class="share-dimmed"></div>
      	<span class="share-txt"><i class="icon-share"></i></span>
      	<div class="share-list">${iconNodes}
        <button class="share-close"><i class="icon-share-close"></i>Close</button>
        </div></div>`;

      return markup;
  }

  bindEvent() {
    this.shareEvent.addCatMessager( this.$shareRoot.find( '.share-cat' ) );
    this.shareEvent.addFacebook( this.$shareRoot.find( '.share-facebook' ) );
    this.shareEvent.addTwitter( this.$shareRoot.find( '.share-twitter' ) );
    this.shareEvent.addGooglePlus( this.$shareRoot.find( '.share-googleplus' ) );
    this.shareEvent.addLine( this.$shareRoot.find( '.share-line' ) );
    this.shareEvent.addKakaoLink( this.$shareRoot.find( '.share-kakaotalk' ) );
    this.shareEvent.addKakaoStory( this.$shareRoot.find( '.share-kakaostory' ) );
  }

  addEvent(){

    let selector = ( this.parentId )? `#${this.parentId}`: `.ncUiKitShare`;

    this.$shareRoot = $( selector );
    let _options = this.options;
    this.shareEvent = new ShareEvent( _options );

    this.bindEvent();

    this.$shareRoot.find( '.share-txt' ).on( 'click', ( evt ) => {
      let breakpoint = _options.breakpoint;
      let windowWidth = $( window ).width();

      if( breakpoint && windowWidth <= breakpoint ){
        this.$shareRoot.addClass( 'active' );
      }
    });

    this.$shareRoot.find( '.share-close' ).on( 'click', ( evt ) => {
      this.$shareRoot.removeClass( 'active' );
    });

    this.$shareRoot.find( '.share-dimmed' ).on( 'click', ( evt ) => {
      this.$shareRoot.removeClass( 'active' );
    });
  }

  resetOptions( options ){
    $.extend( this.options, options );
    this.shareEvent.resetCatMessager( this.$shareRoot.find( '.share-cat' ), this.options );
    this.shareEvent.resetFacebook( this.$shareRoot.find( '.share-facebook' ), this.options );
    this.shareEvent.resetTwitter( this.$shareRoot.find( '.share-twitter' ), this.options );
    this.shareEvent.resetKakaoLink( this.$shareRoot.find( '.share-kakaotalk' ), this.options );
    this.shareEvent.resetKakaoStory( this.$shareRoot.find( '.share-kakaostory' ), this.options );
    this.shareEvent.resetGooglePlus( this.$shareRoot.find( '.share-googleplus' ), this.options );
    this.shareEvent.resetLine( this.$shareRoot.find( '.share-line' ), this.options );
  }

  sort( list ){
    Object.keys( list ).sort( function( a, b ){ return list[ a ] - list[ b ] });
  }

  setMsg( msg ){
    this.options.msg = this.replaceChars( msg );
    this.resetOptions();
  }

  setDescription( txt ){
    this.options.description = this.replaceChars( this.options.description );
    this.resetOptions();
  }
}

export default Share;
